<template>
  <a-config-provider :locale="locale">
    <div id="app" style="overflow: hidden">
      <router-view></router-view>

      <FloatModal :title="$t('components.ViewRoiWall.247370-1')" :defaultWidth="720" :defaultHeight="400">
        <iframe
          v-if="modalUrl"
          style="width: 100%; height: 100%"
          :src="modalUrl"
          frameborder="no"
          framespacing="0"
          scrolling="no"
          allow="autoplay; encrypted-media"
          allowfullscreen="true"
        ></iframe>
      </FloatModal>
    </div>
  </a-config-provider>
</template>

<script>
import bus from '@/utils/bus.js';
import { mapState } from 'vuex';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import FloatModal from '@/components/FloatModal.vue';
import { mixins_mouseIdle } from '@/mixins/index.js';

export default {
  name: 'App',
  components: { FloatModal },
  mixins: [mixins_mouseIdle],
  computed: {
    ...mapState('floatModal', ['modalVisible', 'modalUrl'])
  },
  data() {
    return {
      locale: zhCN
    };
  },
  watch: {
    $route() {
      this.$store.dispatch('floatModal/closeFloatModalIfNeeded');
    }
  },
  created() {},
  mounted() {
    if (window.matchMedia('(orientation: landscape)').matches) {
      localStorage.setItem('ipp_matchMedia', 'landscape');
    } else if (window.matchMedia('(orientation: portrait)').matches) {
      localStorage.setItem('ipp_matchMedia', 'portrait');
    }

    // 监听窗口分辨率变化
    let timer = null;
    window.onresize = () => {
      return (() => {
        clearTimeout(timer);
        timer = setTimeout(function () {
          // 判断横屏、竖屏
          if (window.matchMedia('(orientation: landscape)').matches) {
            localStorage.setItem('ipp_matchMedia', 'landscape');
          } else if (window.matchMedia('(orientation: portrait)').matches) {
            localStorage.setItem('ipp_matchMedia', 'portrait');
          }
          // 通知消息
          bus.$emit('window_resize');
        }, 1000);
      })();
    };
  },
  beforeDestroy() {},
  methods: {}
};
</script>

<style lang="scss">
.icon-left-top-mark {
  position: absolute;
  top: 10px;
  left: 10px;
  user-select: none;
}

.icon-left-bottom-mark {
  position: absolute;
  bottom: 10px;
  left: 10px;
  user-select: none;
}

.icon-right-top-mark {
  position: absolute;
  top: 10px;
  right: 10px;
  user-select: none;
}

.icon-right-bottom-mark {
  position: absolute;
  bottom: 10px;
  right: 10px;
  user-select: none;
}
</style>
